import { createFileRoute, Outlet } from '@tanstack/react-router';

import { requirePermission } from '@/app/guards';

/** Layout for the two-step create flow: the kind chooser at the index, the editor under `$kind`. */
export const Route = createFileRoute('/_authed/_active/s/$storeId/content/blocks/new')({
  staticData: { crumb: 'content:blocks.new' },
  beforeLoad: ({ context }) => {
    requirePermission(context.me, 'content.write');
  },
  component: Outlet,
});
